<template>
  <div
    id="musicRelax"
    ref="musicRelax"
    class="music-relax"
  >
    <div class="start-background">
      <div
        class="star left1"
        style="top: 0px;animation-delay:0s"
      />
      <div
        class="star left2"
        style="top: 0px;animation-delay:1.2s"
      />
      <div
        class="star left3"
        style="top: 0px;animation-delay:0.6s"
      />
      <div
        class="star left4"
        style="top: 0px;animation-delay:2.3s"
      />
      <div
        class="star left5"
        style="top: 0px;animation-delay:3.2s"
      />
      <div
        class="star left6"
        style="top: 0px;animation-delay:2.42s"
      />
    </div>
    <div class="all-contain">
      <div class="audio-status">
        <div
          ref="animation1"
          class="animation2 big-animation"
        />
        <div class="animation3">
          <span class="music-time">{{ metadataTime }}</span>
        </div>
      </div>
      <div class="desc-contain">
        <div class="desc-title">
          {{ toolItemInfo.title }}
        </div>
        <p class="desc-content">
          {{ toolItemInfo.remark }}
        </p>
      </div>
      <div class="s-audio-contain">
        <div v-if="toolItemInfo.audioUrl">
          <vue-audio-native
            id="audioContent"
            size="small"
            :url="toolItemInfo.audioUrl"
            :show-current-time="true"
            :show-controls="false"
            :show-volume="false"
            :show-download="false"
            :autoplay="false"
            hint="音频正在加载中，请稍等…"
            @on-audioId="audioId"
            @on-change="audioOnchange"
            @on-timeupdate="audioTimeupdate"
            @on-metadata="audioMetadata"
          />
        </div>
        <!-- <span>{{ metadataTime }}</span> -->
      </div>
      <div class="button-contain">
        <button
          class="white pause-button"
          @click="closeAudio"
        >
          关闭音频
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      metadataTime: '00:00',
      toolItemInfo: {
        title: '安全地练习',
        remark: '吸气、呼气、最平凡的力量，最深的治愈',
        audioUrl: 'https://bj.download.cycore.cn/CSB-decompression-planet-service/410c7fdd-911c-4823-aa2b-b0847b5a7924/audio1.mp3',
      },
      currentAudioId: []
    }
  },
  destroyed () {
    // this.$refs['animation1'].style.animationPlayState = 'paused'
  },
  mounted () {

    const music = document.getElementById("audioContent")
    music.addEventListener('canplay', function () {
      console.log('播放技术')
    })
  },
  methods: {
    audioId (event) {
      console.log(event, 'audioId')
      this.currentAudioId = event;
      this.$emit("audioObjectId", this.currentAudioId)
    },
    audioOnchange (status) {
      console.log(88888, status)
      if (status) {
        this.$refs['animation1'].style.animationPlayState = 'running'
      } else {
        setTimeout(() => {
          this.$refs['animation1'].style.animationPlayState = 'paused'
        }, 500)
      }
    },
    audioTimeupdate (event) {
      console.log(event, 'audioTimeupdate')
      this.$refs['animation1'].style.animationPlayState = 'running'
      let value = this.meadiuAllTime - event
      if (value <= 0) {
        this.musicTimeStart()
        return
      }
      let fen = Math.floor(value / 60)
      if (fen <= 9) {
        this.metadataTime = "0" + fen + ":"
      }
      let second = Math.floor(value - fen * 60)
      if (second <= 9) {
        second = "0" + second
      }
      this.metadataTime += second
    },
    audioMetadata (value) {
      console.log(value, 'audioMetadata')
      this.meadiuAllTime = value.target.duration
      this.musicTimeStart()
    },
    // 计算时间
    musicTimeStart () {
      let fen = Math.floor(this.meadiuAllTime / 60)
      if (fen <= 9) {
        this.metadataTime = "0" + fen + ":"
      }
      let second = Math.floor(this.meadiuAllTime - fen * 60)
      if (second <= 9) {
        second = "0" + second
      }
      this.metadataTime += second
    },
    closeAudio () {
      document.getElementById(this.currentAudioId).pause();
      this.toolItemInfo.audioUrl = null
      this.$emit('setShowAudio', false)
    },
    getAudioInfo () {
      this.toolItemInfo.audioUrl = 'https://bj.download.cycore.cn/CSB-decompression-planet-service/410c7fdd-911c-4823-aa2b-b0847b5a7924/audio1.mp3'
    }
  }
}
</script>

<style lang="scss" scoped>
.music-relax {
  position: relative;
  height: 100%;
  width: 100%;
  .start-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    .star {
      display: block;
      width: 1px;
      background: transparent;
      position: relative;
      opacity: 0;
      /*过渡动画*/
      animation: star-fall 4.2s linear infinite;
      -webkit-animation: star-fall 4.2s linear infinite;
      -moz-animation: star-fall 4.2s linear infinite;
    }

    .star:after {
      content: "";
      display: block;
      border: 0px solid #fff;
      border-width: 0px 90px 2px 90px;
      border-color: transparent transparent transparent rgba(255, 255, 255, 0.5);
      box-shadow: 0 0 1px 0 rgba(255, 255, 255, 0.1);
      /*变形*/
      transform: rotate(-45deg) translate3d(1px, 3px, 0);
      -webkit-transform: rotate(-45deg) translate3d(1px, 3px, 0);
      -moz-transform: rotate(-45deg) translate3d(1px, 3px, 0);
      transform-origin: 0% 100%;
      -webkit-transform-origin: 0% 100%;
      -moz-transform-origin: 0% 100%;
    }
    .left1 {
      left: 200px;
    }
    .left2 {
      left: 600px;
    }
    .left3 {
      left: 990px;
    }
    .left4 {
      left: 1290px;
    }
    .left5 {
      left: 1500x;
    }
    .left6 {
      left: 1700px;
    }
  }
  .all-contain {
    position: absolute;
    bottom: 24%;
    height: 56.5%;
    width: 100%;
    // background: chartreuse;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    flex-direction: column;
  }
  .audio-status {
    width: 230px;
    height: 322px;
    position: relative;
    .animation2,
    .animation3 {
      width: 230px;
      height: 230px;
      border: 1px solid #ffffff;
      border-radius: 55%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      .music-time {
        font-size: 32px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .big-animation {
      animation: spread 3s infinite;
      animation-play-state: paused;
    }
  }
  .desc-contain {
    width: 100%;
    height: 120px;
    text-align: center;
    .desc-title {
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 42px;
    }
    .desc-content {
      margin-top: 10px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 28px;
    }
  }
  .button-contain {
    width: 173px;
    height: 61px;
    position: relative;
    button {
      position: absolute;
      top: 0;
      border: 1px solid rgba(255, 255, 255, 0.2);
      outline: none;
      height: 70px;
      width: 116px;
      border-radius: 40px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 70px;
      background: transparent;
      padding: 0;
      box-sizing: border-box;
    }
    .white {
      width: 100%;
      height: 100%;
      line-height: 59px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 31px;
    }
    .left-transition {
      z-index: 0.5s;
      transition: left 0.5s linear;
      -webkit-transition: left 0.5s linear;
    }
    .right-transition {
      right: 50px;
      transition: right 0.5s linear;
      -webkit-transition: right 0.5s linear;
    }
  }
  .s-audio-contain {
    margin-bottom: 82px;
    width: 920px;
    height: 35px;
    display: flex;
    align-items: center;
    // margin-top: 15px;
    position: relative;
    /deep/ .vueAudioNative {
      padding: 5px 0;
      justify-content: start;
      .hint {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        width: 920px;
      }
    }
    /deep/ .audio-left {
      justify-content: start;
      b {
        margin-right: 16px;
      }
      .iconfont {
        font-size: 48px;
      }
      span {
        position: absolute;
        right: 0;
        width: 136px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 33px;
      }
    }
    /deep/ .audio-right {
      width: 700px;
      margin-right: 16px;
      flex: initial;
      .slider {
        height: 8px;
        background: rgba(237, 237, 237, 0.2);
        .slider-btn {
          display: none;
        }
      }
    }
  }
}
</style>